import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useAssignmentReview } from "../globals/AssignmentReviewContext";
import { fetchUserByID } from "../actions/fetchUserByID";
import QuestionReview from "../components/QuestionReview";
import { fetchAssignmentActionSimple } from "../actions/fetchAssignment";
import Dayjs from "dayjs";
import { useUser } from "../globals/UserContext";

export default function AssignmentReview() {
  const assignmentReview = useAssignmentReview();
  const [assignmentObj, setAssignmentObj] = useState({});
  const [user, setUser] = useState(assignmentReview.user ?? "");
  const [studentAnswers, setStudentAnswers] = useState([]);
  const [shouldShowReview, setShouldShowReview] = useState(false);
  const userIsTeacher = useUser().isTeacher;
  useEffect(() => {
    if (!assignmentReview.user) {
      fetchUserByID(assignmentReview.userID).then((res) => setUser(res));
    }
  }, [assignmentReview.user, assignmentReview.userID]);

  useEffect(() => {
    const targetAssignment = user?.assignment_attempts?.find(
      (assignment) => assignment.assignment === assignmentReview.assignmentID
    );
    if (targetAssignment?.answers.length) {
      setStudentAnswers([...targetAssignment?.answers]);
    }
  }, [user, assignmentReview.assignmentID]);

  useEffect(() => {
    fetchAssignmentActionSimple(assignmentReview.assignmentID).then((res) =>
      setAssignmentObj(() => res)
    );
  }, []);

  useEffect(() => {
    const shouldShow =
      userIsTeacher || Date.parse(assignmentObj?.due_date) < Date.parse(now);
    setShouldShowReview(() => shouldShow);
  }, [assignmentObj, user]);

  useEffect(() => {
    console.log(studentAnswers);
  }, []);

  const now = Dayjs(Date.now());

  if (shouldShowReview) {
    return studentAnswers.length ? (
      <Grid
        container
        direction="column"
        sx={{ paddingTop: "90px", px: "15px" }}
      >
        <Typography variant="h4" textAlign="center">
          {assignmentReview?.userID
            ? `Review ${user?.name}'s assignment`
            : "Review your assignment"}
        </Typography>
        <Grid item>
          {studentAnswers?.map((answer, index) => {
            return (
              <QuestionReview
                key={index}
                answer={answer}
                index={index}
                isTeacher={userIsTeacher}
              />
            );
          })}
        </Grid>
      </Grid>
    ) : (
      <Grid container item sx={{ paddingTop: "90px", px: "15px" }}>
        <Typography variant="h4" textAlign="center">
          No Submission
        </Typography>
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        direction="column"
        sx={{ paddingTop: "70px", px: "15px" }}
      >
        <Typography variant="h4" textAlign="center">
          {assignmentReview?.userID
            ? `Review ${user?.name}'s assignment`
            : "Review your assignment"}
        </Typography>
        <Typography variant="subtitle1">
          Assignment Submitted! Come back after{" "}
          {Dayjs(assignmentObj.due_date).format("MMMM D, YYYY")} at{" "}
          {Dayjs(assignmentObj.due_date).format("h:mm A")} to review your
          assignment.
        </Typography>
      </Grid>
    );
  }
}
